import queryString from 'query-string';
export const setUrl = (query: any) => {
  // @ts-ignore
  if (history.pushState) {
    const newUrl = queryString.stringifyUrl({
      // @ts-ignore
      url: window.location.href,
      query,
    });
    // @ts-ignore
    window.location = newUrl;
  }
};
